import {ChangeDetectionStrategy, Component} from '@angular/core';

/**
 * Panel Component
 *
 * @ngModule PanelsModule
 */
@Component({
  selector: 'maia-panel-title',
  template: '<ng-content></ng-content>',
  styleUrls: ['./panel-title.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PanelTitleComponent {}
